import React, { Component } from 'react';
import classnames from 'classnames';
import Tooltip from '@tencent/dui/lib/components/Tooltip';

import Style from './index.less';
import i18n from '@i18next/i18n';

interface IHistoryItemProps {
    item: any;
    selected: boolean;
    selectedSub: boolean | undefined;
    maxVersion: any;
    onItemRevertClick: (index?: number) => void;
    onItemClick: (index?: number) => void;
    getAuthor(...args: any): any;
    getColor(...args: any): any;
}

interface IHistoryItemStates {
    unfolding: boolean;
    mainHover: boolean;
    subHover: boolean;
    subHoverIndex: number;
}

export default class HistoryItem extends Component<IHistoryItemProps, IHistoryItemStates> {
    public constructor(props) {
        super(props);
        this.state = {
            unfolding: false,
            mainHover: false,
            subHover: false,
            subHoverIndex: -1,
        };
    }

    public render() {
        const { item } = this.props;
        const version = item.v;
        const time = this.formatTime(item.t, 'yyyy/MM/dd hh:mm:ss');
        const authors = item.a;
        const showUnfold = this.showUnfold();
        const selectedMain = this.props.selected && typeof (this.props.selectedSub) === 'undefined';
        const isRevert = !!item.r;
        const revertInfo = this.getRevertInfo();
        const showAuthorList = this.showAuthorList();
        const showAuthorCount = this.showAuthorCount(showAuthorList, authors);
        const showSubItems = this.showSubItems(isRevert);
        const isCurrentVersion = this.props.maxVersion === version;
        return (
            <div className={Style['history-item-wrapper']} onMouseOver={this.handleMouseOver.bind(this)} onMouseLeave={this.handleMouseLeave.bind(this)}>
                <div
                    className={classnames(Style['main-content'], selectedMain ? Style.selected : null)}
                    onClick={this.onItemClick.bind(this)}>
                    {this.renderUnfold(showUnfold)}
                    { this.renderRevertIcon(selectedMain, isCurrentVersion)}
                    <div className={Style.version}>{`${i18n.t('第{0}版', { 0: version })}${isCurrentVersion ? i18n.t('(当前)') : ''}`}</div>
                    <div className={Style.time}>{time}</div>
                    {showAuthorList ? this.renderAuthorList(authors) : null}
                    {isRevert ? <div className={Style['revert-info']}>{revertInfo}</div> : null}
                    {showAuthorCount ? <div className={Style['author-count']}>{i18n.t('等{0}人修改了文档', { 0: authors.length })}</div> : null }
                </div>
                {showSubItems ? this.renderSubItem(item) : null}
            </div>
        );
    }

    private onFoldButtonClick(event) {
        this.setState({
            unfolding: !this.state.unfolding,
        });
        event.stopPropagation();
    }

    private onRevertButtonClick(event) {
        this.props.onItemRevertClick();
        event.stopPropagation();
    }

    private onSubRevertButtonClick(index, event) {
        this.props.onItemRevertClick(index);
        event.stopPropagation();
    }

    private onItemClick() {
        this.props.onItemClick();
    }

    private onSubItemClick(index) {
        this.props.onItemClick(index);
    }

    private handleMouseOver() {
        this.setState({
            mainHover: true,
        });
    }

    private handleMouseLeave() {
        this.setState({
            mainHover: false,
        });
    }

    private handleSubMouseOver(index) {
        this.setState({
            subHover: true,
            subHoverIndex: index,
        });
    }

    private handleSubMouseLeave() {
        this.setState({
            subHover: false,
            subHoverIndex: -1,
        });
    }

    private formatTime(time, fmt) {
        const date = new Date();
        date.setTime(time);
        const o = {
            'M+': date.getMonth() + 1, // 月份
            'd+': date.getDate(), // 日
            'h+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
            S: date.getMilliseconds(), // 毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
        for (const k in o) if (new RegExp(`(${k})`).test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
        return fmt;
    }

    private renderAuthorList(authors) {
        let renderAuthors: any[] | null = null;
        if (authors.length > 4) {
            renderAuthors = authors.slice(0, 5);
        } else {
            renderAuthors = authors;
        }
        return (
            <ul className={Style['author-list']}>
                {renderAuthors?.map((a) => {
                    const author = this.props.getAuthor(a);
                    const name = author ? author.name : '';
                    return (
                        <li className={Style.author} key={a}>
                            <div className={Style['author-dot']} style={{ backgroundColor: this.props.getColor(a) }} />
                            <div className={Style['author-text']}>{name}</div>
                        </li>
                    );
                })}
            </ul>
        );
    }

    private renderSubItem(item) {
        const version = item.v;
        const isCurrentVersion = this.props.maxVersion === version;
        const list = item.l;
        const { selectedSub } = this.props;
        return (
            <ul className={Style['sub-item-list']}>
                {list.map((l, index) => {
                    const time = this.formatTime(l.t, 'hh:mm:ss');
                    const author = this.props.getAuthor(l.a);
                    const name = author ? author.name : '';
                    const canRevert = !(isCurrentVersion && index === 0);
                    return (
                        <li
                            className={classnames(Style['sub-item'], selectedSub === index ? Style.selected : null)}
                            key={l.i}
                            onClick={this.onSubItemClick.bind(this, index)}
                            onMouseOver={this.handleSubMouseOver.bind(this, index)}
                            onMouseLeave={this.handleSubMouseLeave.bind(this, index)}>
                            { (selectedSub === index || this.state.subHoverIndex === index) && canRevert
                                ? <div className={Style.revert} onClick={this.onSubRevertButtonClick.bind(this, index)}>
                                    <div className={Style['revert-icon']}></div>
                                    <div className={Style['revert-text']}>{i18n.t('还原')}</div>
                                </div> : null
                            }
                            <div className={Style['sub-item-time']}>{time}</div>
                            <div className={Style['sub-item-author']}>
                                <div className={Style['sub-item-author-dot']} style={{ backgroundColor: this.props.getColor(l.a) }} />
                                <div className={Style['sub-item-author-text']}>{name}</div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }

    private getRevertInfo() {
        const { item } = this.props;
        const isRevert = !!item.r;
        if (isRevert) {
            let revertTime = 0;
            let revertVersion = 0;
            if (typeof item.r === 'string') {
                const components = item.r.split('_');
                revertTime = parseInt(components[0], 10);
                if (components[1]) {
                    revertVersion = parseInt(components[1], 10);
                }
            } else {
                revertTime = item.r;
            }
            if (revertVersion === 0) {
                return i18n.t('恢复了{0}时的内容', { 0: this.formatTime(revertTime, 'yyyy-MM-dd hh:mm:ss') });
            }
            return i18n.t('恢复了第{0}版的内容', { 0: revertVersion });
        }
    }

    private showAuthorList() {
        return !this.state.unfolding;
    }

    private showAuthorCount(showAuthorList, authors) {
        return showAuthorList && authors.length > 1;
    }

    private showSubItems(isRevert) {
        return !isRevert && this.state.unfolding;
    }

    private showUnfold() {
        const { item } = this.props;
        return  item.l && item.l.length > 1;
    }

    private renderUnfold(showUnfold) {
        return showUnfold
            ? <div className={Style['fold-wrapper']}>
                <Tooltip title={this.state.unfolding ? i18n.t('收起详细记录') : i18n.t('展开详细记录')} placement="bottom">
                    <div
                        className={classnames(Style['fold-button'], Style[this.state.unfolding ? 'unfolding' : 'folding'])}
                        onClick={this.onFoldButtonClick.bind(this)}
                    />
                </Tooltip>
            </div> : null;
    }

    private renderRevertIcon(selectedMain, isCurrentVersion) {
        return (selectedMain || (this.state.mainHover && !this.state.subHover)) && !isCurrentVersion
            ? <div className={Style.revert} onClick={this.onRevertButtonClick.bind(this)}>
                <div className={Style['revert-icon']}></div>
                <div className={Style['revert-text']}>{i18n.t('还原')}</div>
            </div> : null;
    }
}
